{
  "validation.required": "{{label}} は必須フィールドです",
  "validation.minLength": "{{label}} は少なくとも {{min}} 文字の長さが必要です",
  "validation.maxLength": "{{label}} は {{max}} 文字より長くすることはできません",
  "validation.contentTypeAlphanumeric": "{{label}} は英数字である必要があります",
  "validation.contentTypeDate": "{{label}} は日付である必要があります",
  "validation.contentTypeDateBefore": "{{label}} は {{date beforeDate}} より前の日付である必要があります",
  "validation.contentTypeDateAfter": "{{label}} は {{date afterDate}} より後の日付である必要があります",
  "validation.contentTypeDatetime": "{{label}} は日付と時刻である必要があります",
  "validation.contentTypeDatetimeBefore": "{{label}} は {{datetime beforeDate}} より前の日付である必要があります",
  "validation.contentTypeDatetimeAfter": "{{label}} は {{datetime afterDate}} より後の日付である必要があります",
  "validation.contentTypeEmail": "{{label}} は電子メールである必要があります",
  "validation.contentTypeInteger": "{{label}} は数値である必要があります",
  "validation.contentTypeNumber": "{{label}} は数字である必要があります",
  "validation.contentTypeRegex": "{{label}} の形式が間違っています",
  "validation.contentTypeText": "{{label}} はテキストである必要があります",
  "validation.contentTypeTime": "{{label}} は時間である必要があります",
  "validation.contentTypeUrl": "{{label}} は Web アドレスである必要があります",
  "select-element.default-option": "選択する…",
  "button-element.network-required": "現在オフラインです。続行するにはネットワーク接続を確立してください。"
}